/**
 * @param len Length of the password
 * @param upper True if upper cases are included
 * @param nums True if numbers are included
 * @param special True if special characters are included
 * @returns Returns the password
 */
const genPass = (len: number, upper: boolean, nums: boolean, special: boolean) => {
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numChars = "0123456789";
    const specialChars = "!@#$%^&*()-_=+[]{}|;:,.<>?";
    let chars = lower;

    if (upper) chars += upperChars;
    if (nums) chars += numChars;
    if (special) chars += specialChars;

    let pass = "";
    for (let i = 0; i < len; i++) {
        const randIdx = Math.floor(Math.random() * chars.length);
        pass += chars[randIdx];
    }

    return pass;
};

/**
 * @param len Length of the password
 * @param upper True if upper cases are included
 * @param nums True if numbers are included
 * @param special True if special characters are included
 * @param re Regular expression which need to be passed
 * @param maxTry Maximum number of try to generate a valid password
 * @returns Returns a valid password
 */
export const genValidPass = (len: number, upper: boolean, nums: boolean, special: boolean, re: RegExp, maxTry: number = 10) => {
    let pass = genPass(len, upper, nums, special);
    let numTry = 1;

    if (re) {
        while (!re.test(pass) && numTry < maxTry) {
            pass = genPass(len, upper, nums, special);
        }
    }

    return pass;
};